import * as React from 'react';
import { render } from 'react-dom';

import App from './app';
import { unregister } from './serviceWorker';

unregister();
render(<App />, document.getElementById('root'));
